import { render, staticRenderFns } from "./CustomersDataSheetIdentifier.vue?vue&type=template&id=82d01f5c&"
import script from "./CustomersDataSheetIdentifier.vue?vue&type=script&lang=js&"
export * from "./CustomersDataSheetIdentifier.vue?vue&type=script&lang=js&"
import style0 from "./CustomersDataSheetIdentifier.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports